import { setLoading, SetLoadingAction, stopLoading } from './actions';
import { LoadingType } from '../types';

const initialState: LoadingType = 'idle';

function isLoadingReducer(state = initialState, { type, payload }: SetLoadingAction) {
	switch (type) {
		case setLoading.toString():
			return payload;
		case stopLoading.toString():
			return 'idle';
		default:
			return state;
	}
}

export default isLoadingReducer;
